export default __webpack_public_path__ + "static/media/anniversary_ring.a5128794.png";